exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* --------------- Promotion modal --------------- */\n\n.promotion-modal h2 {\n\tfont-size: 24px;\n\tmargin: 0 0 20px 0;\n\tpadding: 0;\n\tcolor: #323a45;\n\ttext-align: center;\n}\n.promotion-modal h3 {\n\tfont-size: 16px;\n\tmargin: 0 0 15px 0;\n\tpadding: 0;\n\tfont-weight: 600;\n\tcolor: #323a45;\n\ttext-align: center;\n}\n.promotion-modal p {\n\tmargin: 0 0 30px 0;\n\tline-height: 1.5;\n\tcolor: #323a45;\n\ttext-align: center;\n}\n.promotion-modal .button {\n\twidth: 100%;\n\theight: 36px;\n\tmargin: 0;\n\tpadding: 0;\n\ttext-align: center;\n}\n.promotion-modal .button .mat-raised-button {\n\twidth: 100%;\n\tfloat: right;\n}\n@media only screen and (min-width: 350px) {\n\t.promotion-modal p {\n\t\tmargin: 0 10% 30px 10%;\n\t}\n\t.promotion-modal .button .mat-raised-button {\n\t\twidth: 186px;\n\t\tfloat: none;\n\t}\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/promotion-modal/promotion-modal.component.css
// module id = ./src/app/shared/components/promotion-modal/promotion-modal.component.css
// module chunks = 1